import { render } from "./areaList.vue?vue&type=template&id=d91cec06&ts=true"
import script from "./areaList.vue?vue&type=script&lang=ts&config=true"
export * from "./areaList.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__